import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useProfile = () => {
  return useMutation(() => {
    return axiosPost("/api/cw/myDetails");
  });
};

export default useProfile;
